const reasons = [
  {
    icon: "ri-earth-line",
    title: "Cross-Border Perspective",
    desc: "We understand the unique challenges and opportunities facing diaspora investors navigating multiple markets, currencies, and regulatory environments.",
  },
  {
    icon: "ri-heart-line",
    title: "Diaspora-Centered Mission",
    desc: "Our platform was built specifically for the African Diaspora and emerging investors &mdash; our mission is personal, not just professional.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Professional & Transparent",
    desc: "No hype, no guaranteed returns, no shortcuts. We operate with discipline, honesty, and a commitment to credible, responsible advisory.",
  },
  {
    icon: "ri-time-line",
    title: "Long-Term Value Focus",
    desc: "We prioritize sustainable, intergenerational wealth creation over quick wins &mdash; because real wealth is built over time, not overnight.",
  },
  {
    icon: "ri-shake-hands-line",
    title: "Relationship-Driven",
    desc: "Every client engagement is built on trust and genuine understanding. We take the time to know your goals before offering any guidance.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Nairobi-Anchored, Globally Relevant",
    desc: "Our Nairobi base gives us deep African market insight, while our cross-border network ensures global relevance for diaspora clients worldwide.",
  },
];

export default function WhyChooseHarambee() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left - Content */}
        <div>
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Why Harambee
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            What Sets Our Advisory Platform Apart
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-10">
            In a world full of financial noise, Harambee Global Ventures offers something different &mdash; a disciplined, credible, and deeply human approach to advisory that puts your long-term wellbeing first.
          </p>

          <div className="space-y-5">
            {reasons.map((reason) => (
              <div
                key={reason.title}
                className="flex items-start gap-5 group"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors flex-shrink-0 mt-0.5">
                  <i className={`${reason.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <h3 className="font-semibold text-[#2B2D2F] text-sm mb-1">
                    {reason.title}
                  </h3>
                  <p className="text-[#6B6B6B] text-xs leading-relaxed">
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Image */}
        <div className="relative">
          <img
            src="/assets/images/site/adv-why-001-800x900.jpg"
            alt="Why choose Harambee Global Ventures advisory services"
            className="w-full h-[600px] object-cover object-top rounded-lg"
          />
          {/* Floating stat card */}
          <div className="absolute -top-6 -left-6 bg-white border border-[#E8E4DC] rounded-lg p-6 max-w-[200px] hidden md:block">
            <div className="font-['Cormorant_Garamond'] text-4xl font-bold text-[#1A4D3C] mb-1">
              7 Hills
            </div>
            <div className="text-[#6B6B6B] text-xs leading-relaxed">
              Development Group LLC &mdash; the trusted parent company behind Harambee Global Ventures
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
